import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { message } from 'antd';
// import { history } from 'app/history';
import {
  get_Countrycodes,
  occupation_Data,
  get_MStatus,
  get_FamilyStatus,
  get_FamilyValue,
  get_FamilyType,
  create_family,
  get_statusData,
  detailsList
} from './api';

const initialState = {
  loading: false,
  createEducationDetailsloading: false,
  country_codes: [],
  Occupation_Data: [],
  maritial_Status: [],
  family_Status: [],
  family_Value: [],
  family_Type: [],
  siblings_maritialStatus: [],
  get_hobbies_list: [],
  get_sports_list: [],
  education_details: [],
  department_details: [],
  city_details: [],
  state_details: [],
  user_data: [],
  currency_data: [],
  cityInfo: [],
  education_level_listdata: [],
  education_degree_listdata: []
};

const actions = {
  COUNTRYCODES: 'countryCodes/COUNTRYCODES',
  OCCUPATIONDATA: 'occupationData/OCCUPATIONDATA',
  MARITIAL_STATUS: 'maritialStatus/MARITIAL_STATUS',
  FAMILY_STATUS: 'familyStatus/FAMILY_STATUS',
  FAMILY_VALUE: 'familyValue/FAMILY_VALUE',
  FAMILY_TYPE: 'familyType/FAMILY_TYPE',
  SIBLINGS_MARITIAL_STATUS: 'siblings_maritial_Status/SIBLINGS_MARITIAL_STATUS',
  HOBBIES_LIST: 'hobbies_list/HOBBIES_LIST',
  SPORTS_LIST: 'sports_list/SPORTS_LIST',
  EDUCATION_LIST: 'education_list/EDUCATION_LIST',
  DEPARTMENT_LIST: 'department_list/DEPARTMENT_LIST',
  CITIES_LIST: 'cities_list/CITIES_LIST',
  CREATE_FAMILYDETAILS: 'createFamilyDetails/CREATE_FAMILYDETAILS',
  CREATE_EDUCATIONDETAILS: 'createEducationDetails/CREATE_EDUCATIONDETAILS',
  STATECODES: 'stateCodes/STATECODES',
  GET_BYID: 'get_byID/GET_BYID',
  Currency_Codes: 'currencyCodes/Currency_Codes',
  GETCITYDETAILS: 'getCityDetails/GETCITYDETAILS',
  EDUCATION_LEVEL_LIST: 'education_level_list/EDUCATION_LEVEL_LIST',
  GET_HIGHEREDUCATIONOPTIONS:
    'getHigherEducationOptions/GET_HIGHEREDUCATIONOPTIONS'
};

export const get_byID = createAsyncThunk(actions.GET_BYID, async (payload) => {
  const response = await detailsList(payload);
  return response;
});

export const countryCodes = createAsyncThunk(
  actions.COUNTRYCODES,
  async (payload) => {
    const response = await get_Countrycodes('countries-list', payload);
    return response;
  }
);

// currencyCodes/Currency_Codes
export const currencyCodes = createAsyncThunk(
  actions.Currency_Codes,
  async (payload) => {
    const response = await get_MStatus('currencies-list', payload);
    return response;
  }
);

// occupationData/OCCUPATIONDATA
export const occupationData = createAsyncThunk(
  actions.OCCUPATIONDATA,
  async (payload) => {
    const response = await occupation_Data('occupations-list', payload);
    return response;
  }
);
// maritialStatus/MARITIAL_STATUS
export const maritialStatus = createAsyncThunk(
  actions.MARITIAL_STATUS,
  async (payload) => {
    const response = await get_MStatus('marital-status-list', payload);
    return response;
  }
);
// familyStatus/FAMILY_STATUS
export const familyStatus = createAsyncThunk(
  actions.FAMILY_STATUS,
  async (payload) => {
    const response = await get_FamilyStatus('family-status-list', payload);
    return response;
  }
);
// familyValue/FAMILY_VALUE
export const familyValue = createAsyncThunk(
  actions.FAMILY_VALUE,
  async (payload) => {
    const response = await get_FamilyValue('family-values-list', payload);
    return response;
  }
);
// familyType/FAMILY_TYPE
export const familyType = createAsyncThunk(
  actions.FAMILY_TYPE,
  async (payload) => {
    const response = await get_FamilyType('family-types-list', payload);
    return response;
  }
);
// siblings_maritialStatus/SIBLINGS_MARITIAL_STATUS
export const siblings_maritial_Status = createAsyncThunk(
  actions.SIBLINGS_MARITIAL_STATUS,
  async (payload) => {
    const response = await get_MStatus('marital-status-list', payload);
    return response;
  }
);
// hobbies_list/HOBBIES_LIST
export const hobbies_list = createAsyncThunk(
  actions.HOBBIES_LIST,
  async (payload) => {
    const response = await get_MStatus('hobby-sports-list', payload);
    return response;
  }
);
// sports_list/SPORTS_LIST
export const sports_list = createAsyncThunk(
  actions.SPORTS_LIST,
  async (payload) => {
    const response = await get_MStatus('hobby-sports-list', payload);
    return response;
  }
);
// education_list/EDUCATION_LIST
export const education_list = createAsyncThunk(
  actions.EDUCATION_LIST,
  async (payload) => {
    const response = await get_MStatus('higher-education-list', payload);
    return response;
  }
);
// department_list/DEPARTMENT_LIST
export const department_list = createAsyncThunk(
  actions.DEPARTMENT_LIST,
  async (payload) => {
    const response = await get_MStatus('departments-list', payload);
    return response;
  }
);
// cities_list/CITIES_LIST
export const cities_list = createAsyncThunk(
  actions.CITIES_LIST,
  async (payload) => {
    const response = await get_MStatus('cities-list', payload);
    return response;
  }
);

// getCityDetails/GETCITYDETAILS
export const getCityDetails = createAsyncThunk(
  actions.GETCITYDETAILS,
  async (cityId) => {
    console.log('getCityDetails', cityId);
    const response = await get_MStatus(`city-detail?id=${cityId}`);
    return response;
  }
);

// createFamilyDetails/CREATE_FAMILYDETAILS
export const createFamilyDetails = createAsyncThunk(
  actions.CREATE_FAMILYDETAILS,
  async (payload) => {
    const response = await create_family('family-details', payload);
    return response;
  }
);

// createEducationDetails/CREATE_EDUCATIONDETAILS
export const createEducationDetails = createAsyncThunk(
  actions.CREATE_EDUCATIONDETAILS,
  async (payload) => {
    const response = await create_family('educations', payload);
    return response;
  }
);

// stateCodes/STATECODES
export const stateCodes = createAsyncThunk(
  actions.STATECODES,
  async (payload) => {
    const response = await get_statusData('states-list', payload);
    return response;
  }
);

// education_level_list/EDUCATION_LEVEL_LIST
export const education_level_list = createAsyncThunk(
  actions.EDUCATION_LEVEL_LIST,
  async (payload) => {
    const response = await get_MStatus('education-levels-list', payload);
    return response;
  }
);

// getHigherEducationOptions/GET_HIGHEREDUCATIONOPTIONS
export const getHigherEducationOptions = createAsyncThunk(
  actions.GET_HIGHEREDUCATIONOPTIONS,
  async (payload) => {
    console.log('getHigherEducationOptions', payload);
    const response = await get_MStatus('higher-education-list', payload);
    return response;
  }
);

export const EditEducationSlice = createSlice({
  name: 'editeducation',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(countryCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(countryCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.country_codes = data;
      })
      .addCase(countryCodes.rejected, (state) => {
        state.loading = false;
      });

    // occupationData
    builder
      .addCase(occupationData.pending, (state) => {
        state.loading = true;
      })
      .addCase(occupationData.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.Occupation_Data = data;
      })
      .addCase(occupationData.rejected, (state) => {
        state.loading = false;
      });

    // maritialStatus
    builder
      .addCase(maritialStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(maritialStatus.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.maritial_Status = data;
      })
      .addCase(maritialStatus.rejected, (state) => {
        state.loading = false;
      });

    // familyStatus
    builder
      .addCase(familyStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyStatus.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Status = data;
      })
      .addCase(familyStatus.rejected, (state) => {
        state.loading = false;
      });

    // currencyCodes
    builder
      .addCase(currencyCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(currencyCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_currency', data);
        state.loading = false;
        state.currency_data = data;
      })
      .addCase(currencyCodes.rejected, (state) => {
        state.loading = false;
      });

    // familyValue
    builder
      .addCase(familyValue.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyValue.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Value = data;
      })
      .addCase(familyValue.rejected, (state) => {
        state.loading = false;
      });

    // familyType
    builder
      .addCase(familyType.pending, (state) => {
        state.loading = true;
      })
      .addCase(familyType.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.family_Type = data;
      })
      .addCase(familyType.rejected, (state) => {
        state.loading = false;
      });

    // siblings_maritialStatus
    builder
      .addCase(siblings_maritial_Status.pending, (state) => {
        state.loading = true;
      })
      .addCase(siblings_maritial_Status.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.siblings_maritialStatus = data;
      })
      .addCase(siblings_maritial_Status.rejected, (state) => {
        state.loading = false;
      });

    // hobbies_list
    builder
      .addCase(hobbies_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(hobbies_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.get_hobbies_list = data;
      })
      .addCase(hobbies_list.rejected, (state) => {
        state.loading = false;
      });

    // sports_list
    builder
      .addCase(sports_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(sports_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.get_sports_list = data;
      })
      .addCase(sports_list.rejected, (state) => {
        state.loading = false;
      });

    // education_list
    builder
      .addCase(education_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(education_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.education_details = data;
      })
      .addCase(education_list.rejected, (state) => {
        state.loading = false;
      });

    // department_list
    builder
      .addCase(department_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(department_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.department_details = data;
      })
      .addCase(department_list.rejected, (state) => {
        state.loading = false;
      });

    // cities_list
    builder
      .addCase(cities_list.pending, (state) => {
        state.loading = true;
      })
      .addCase(cities_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.city_details = data;
      })
      .addCase(cities_list.rejected, (state) => {
        state.loading = false;
      });

    // getCityDetails
    builder
      .addCase(getCityDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCityDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.cityInfo = data;
      })
      .addCase(getCityDetails.rejected, (state) => {
        state.loading = false;
      });

    // createFamilyDetails
    builder
      .addCase(createFamilyDetails.pending, (state) => {
        state.loading = true;
      })
      .addCase(createFamilyDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_data', action.payload);
        state.loading = false;
        state.city_details = data;

        // if (success) {
        //   // history.push('/login');
        //   message.success(msg, [1]);
        // } else {
        //   message.error(msg);
        // }
      })
      .addCase(createFamilyDetails.rejected, (state) => {
        state.loading = false;
      });

    // createEducationDetails
    builder
      .addCase(createEducationDetails.pending, (state) => {
        state.createEducationDetailsloading = true;
      })
      .addCase(createEducationDetails.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_data', action.payload);
        state.createEducationDetailsloading = false;
        state.city_details = data;
      })
      .addCase(createEducationDetails.rejected, (state) => {
        state.createEducationDetailsloading = false;
      });

    // stateCodes
    builder
      .addCase(stateCodes.pending, (state) => {
        state.loading = true;
      })
      .addCase(stateCodes.fulfilled, (state, action) => {
        const { data } = action.payload;
        state.loading = false;
        state.state_details = data;
      })
      .addCase(stateCodes.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(get_byID.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(get_byID.fulfilled, (state, action) => {
        const { data } = action.payload;
        console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.user_data = data;

        // console.log('slicelog', data);
      })
      .addCase(get_byID.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // education_level_list
    builder
      .addCase(education_level_list.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(education_level_list.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.education_level_listdata = data;

        // console.log('slicelog', data);
      })
      .addCase(education_level_list.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });

    // getHigherEducationOptions
    builder
      .addCase(getHigherEducationOptions.pending, (state) => {
        state.acceptedLoading = true;
      })
      .addCase(getHigherEducationOptions.fulfilled, (state, action) => {
        const { data } = action.payload;
        // console.log('slice_View', data.Profiles);
        // state.allOnBoardingList = data.items ? data.items : [];
        // state.pagination = data.meta || null;
        state.education_degree_listdata = data;

        // console.log('slicelog', data);
      })
      .addCase(getHigherEducationOptions.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.acceptedLoading = false;
        message.error(msg);
      });
  }
});

export default EditEducationSlice.reducer;
